<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-analytics"
    sizeClass="modal-fullscreen modal-h100"
    :showFooter="false">

    <div class="chart-container">
      <VChart :option="chartOptions" autoresize v-if="hasChartSeries" />
    </div>
    
  </ModalDialog>
</template>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>

<script>
import _ from 'lodash'

import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart, LineChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent, GraphicComponent, MarkLineComponent } from 'echarts/components';
import VChart from 'vue-echarts';

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  GridComponent,
  GraphicComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  MarkLineComponent
]);


export default {
  name: 'ChartBarPopupDialog',
  mixins: [
    modalDialog
  ],
  components: {
    ModalDialog,
    VChart
  },
  props: {
    title: {
      type: String,
      default: 'Chart'
    },
  },
  data() {
    return {
      series: [],
      xAxis: {},
      yAxis: {},
      legend: {},
      options: {}
    }
  },
  mounted() {
    
  },
  computed: {
    hasChartSeries() {
      if(this.series) {
        return this.series.some(series => {
          if(series.data && series.data.length > 0)
            return true
        })
      }
      return false
    },
    chartOptions() {
      var output = {}

      output.legend = this.legend
      output.xAxis = this.xAxis
      output.yAxis = this.yAxis
      output.series = this.series

      // Default options
      output.tooltip = {
        trigger: 'axis'
      },

      _.merge(output, this.options)

      return output
    }    
  },
  methods: {
    show(params) {

      this.series = params.series
      this.xAxis = params.xAxis
      this.yAxis = params.yAxis
      this.legend = params.legend
      this.options = params.options || {}

      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },

  }
}
</script>